import React from "react";
import useTranslation from "@hooks/use_translation";
import type { GhrTask } from "@/types/task";
import TaskCard from "./TaskCard";
import FormIcon from "@/sprout/icons/form";
import JobInfo from "./JobInfo";

interface TaskCardProps {
  statusText: string;
  task: GhrTask;
}

const ApplicationFormTask: React.FC<TaskCardProps> = ({ statusText, task }) => {
  const { t } = useTranslation("tasks");

  return (
    <TaskCard
      icon={<FormIcon />}
      statusText={statusText}
      task={task}
      title={t("application_form.title")}
      body={<JobInfo task={task} />}
      actionHref={task.url}
      actionText={t("application_form.fill_out_form")}
      theme={{
        colors: {
          background: "bg-white",
          border: "border-gray-700",
          iconBackground: "bg-gray-500",
        },
      }}
      dismissable={false}
    />
  );
};

export default ApplicationFormTask;
